module.exports = __webpack_public_path__ + "assets/img/ArtyWilmotte_001.f49276fe-ps.jpg";